import React from 'react';
import { KeyRound } from 'lucide-react';
import PasswordField from '../../../components/Forms/Input/PasswordField';

interface Props {
  form: { password: string | null; confirmPassword: string | null };
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  /** En edición la contraseña es opcional. */
  optional?: boolean;
}

const UserPasswordSection: React.FC<Props> = ({
  form,
  onChange,
  errors,
  optional = false,
}) => {
  return (
    <section className="rounded-xl border border-stroke bg-white p-5 dark:border-strokedark dark:bg-boxdark-2">
      <div className="mb-1 flex items-center gap-2">
        <KeyRound className="h-5 w-5 text-primary" />
        <h3 className="text-base font-semibold text-black dark:text-white">
          Seguridad
        </h3>
      </div>

      {optional && (
        <p className="mb-4 text-sm text-body dark:text-bodydark2">
          Deja estos campos en blanco para conservar la contraseña actual.
        </p>
      )}

      <div className={`grid grid-cols-1 gap-5 sm:grid-cols-2 ${optional ? '' : 'mt-4'}`}>
        <PasswordField
          label="Contraseña"
          name="password"
          value={form.password ?? ''}
          onChange={(e) => onChange('password', e.target.value)}
          error={errors.password}
          placeholder="Ingrese una contraseña segura"
          showStrength
          required={!optional}
        />

        <PasswordField
          label="Confirmar contraseña"
          name="confirmPassword"
          value={form.confirmPassword ?? ''}
          onChange={(e) => onChange('confirmPassword', e.target.value)}
          error={errors.confirmPassword}
          placeholder="Repita la contraseña"
          required={!optional}
        />
      </div>
    </section>
  );
};

export default UserPasswordSection;
